<template>
  <VHover v-slot:default="{ hover }">
    <VSheet
      :elevation="hover ? 2 : 0"
      class="candidate-slider-item d-flex align-center"
      :class="{ next: next, prev: prev }"
      @click="showCandidate"
    >
      <VBadge
        v-if="candidate.isNew"
        color="red"
        :content="$t('new')"
        bottom
        class="text-uppercase newBadge"
        :left="prev"
        :class="{ prev: prev }"
      />
      <VBadge
        v-if="candidate.selfRefused"
        color="red"
        :content="$t('selfRefused')"
        bottom
        class="text-uppercase newBadge"
        :left="prev"
        :class="{ prev: prev }"
      />
      <CandidateAvatar
        :candidate="candidate"
        size="40"
        class="mx-3"
        empty-icon=""
      />
      <div class="candidate-slider-item__item-summary" :class="{ 'text-right': prev }">
        <div>
          {{ candidate.lastName }} {{ candidate.firstName }}
        </div>
      </div>
      <VIcon size="20">
        {{ 'mdi-arrow-' + (prev ? 'left' : 'right') }}
      </VIcon>
    </VSheet>
  </VHover>
</template>

<script>
import CandidateAvatar from './CandidateAvatar.vue';

export default {
  name: 'CandidateSliderItem',
  components: { CandidateAvatar },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    prev: {
      type: Boolean,
      required: false,
      default: false,
    },
    next: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    showCandidate() {
      this.$router.push({ name: 'candidate', params: { candidateId: this.candidate.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
  .newBadge {
    z-index: 2;
    position: relative;
    top: 18px;
    left: 7px;

    &.prev {
      left: auto;
      right: 7px;
    }
  }

  .candidate-slider-item {
    cursor: pointer;
    width: 100%;
    height: 50px;
    border: 1px solid #E0E0E0;

    &__item-summary {
      font-size: 12px;
      line-height: 16.8px;
    }

    &.next {
      .v-icon {
        margin-left: auto;
        margin-right: 10px;
      }
    }

    &.prev {
      flex-direction: row-reverse;

      .v-icon {
        margin-right: auto;
        margin-left: 10px;
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
  new: New!
  selfRefused: Refused
</i18n>

<i18n locale="ru" lang="yaml">
  new: Новое!
  selfRefused: Отказался
</i18n>
